import React from "react";

const ThreatsIcon = ({ color = "#5D5D5D" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6595 0.387206C11.0633 0.140373 11.5274 0.00976562 12.0007 0.00976562C12.4739 0.00976562 12.938 0.140373 13.3418 0.387206C13.7456 0.634039 14.0735 0.98752 14.2893 1.40872L14.2931 1.4162L23.7203 20.271L23.721 20.2722C23.9178 20.6632 24.0116 21.0983 23.9933 21.5358C23.9749 21.9738 23.845 22.3998 23.6156 22.7733C23.3862 23.1469 23.0653 23.4556 22.683 23.6702C22.3009 23.8849 21.8701 23.9982 21.4318 23.9995H21.4292H2.57211H2.5695C2.13118 23.9982 1.70045 23.8849 1.31825 23.6702C0.936048 23.4556 0.615055 23.1469 0.385754 22.7733C0.156454 22.3998 0.0264583 21.9738 0.0081128 21.5358C-0.0102113 21.0983 0.0834617 20.6634 0.280243 20.2724L0.280936 20.271L9.7083 1.41622L9.71206 1.40871C9.92783 0.987501 10.2557 0.634039 10.6595 0.387206ZM12.0006 7.07115C12.7107 7.07115 13.2863 7.64679 13.2863 8.35686V13.9283C13.2863 14.6384 12.7107 15.214 12.0006 15.214C11.2906 15.214 10.7149 14.6384 10.7149 13.9283V8.35686C10.7149 7.64679 11.2906 7.07115 12.0006 7.07115ZM13.7149 18.6426C13.7149 19.5894 12.9474 20.3569 12.0006 20.3569C11.0539 20.3569 10.2863 19.5894 10.2863 18.6426C10.2863 17.6958 11.0539 16.9283 12.0006 16.9283C12.9474 16.9283 13.7149 17.6958 13.7149 18.6426Z"
        fill="white"
      />
    </svg>
  );
};

export default ThreatsIcon;
